import * as $ from "jquery";
import * as _ from "lodash";

import React, { Component } from "react";
import ReactDOM from "react-dom";
import ScrollMenu from "react-horizontal-scrolling-menu";
//import { UiUtils } from "../common/uiUtils";

const MenuItem = ({ text, selected }) => {
    return <div className={`sd360tour-category-menu-item ${selected ? "active" : ""}`}>{text}</div>;
};

export const Menu = (list, selected) =>
    list.map((el, index) => {
        const { displayName } = el;
        return <MenuItem text={displayName.toUpperCase()} key={index + ""} selected={selected} />;
    });

const Arrow = ({ text, className }) => {
    return (
        <div className={className}>{text}</div>
    );
};

const ArrowLeft = Arrow({ text: "<", className: "arrow-prev" });
const ArrowRight = Arrow({ text: ">", className: "arrow-next" });

interface Category360MenuProps {
    viewer: any;
    categories: any;
    scenes: any;
}

interface Category360MenuState {
    selected: string;
}

class Category360Menu extends React.Component<Category360MenuProps, Category360MenuState> {
    private menuItems;
    private scrollMenu;
    private currentScene: string;

    constructor(props) {
        super(props);
        this.scrollMenu = React.createRef();
        this.menuItems = Menu(props.categories, null);
        this.state = { selected: null };
    }

    componentDidMount(): void {
        this.props.viewer.on("load", this.panoramaLoadedListener.bind(this));
        this.props.viewer.on("scenechange", this.sceneChangeListener.bind(this));
        this.currentScene = this.props.viewer.getScene();
        this.onSelect(0);
        this.scrollMenu.current.resizeHandler();
    }

    onSelect = key => {
        this.setState({ selected: key });

        let exceptCat = this.props.categories.filter(item => item.id !== this.props.categories[key].id).map(item => item.id);
        this.showHotspotsByCategory(this.props.categories[key].id, exceptCat);
    }

    showHotspotsByCategory(visibleCategory, hiddenCategories) {
        if (hiddenCategories) {
            for (let i = 0; i < hiddenCategories.length; i++) {
                let spots = document.getElementsByClassName(hiddenCategories[i]);
                for (let j = 0; j < spots.length; j++) {
                    //spots[j].style.visibility = "hidden";
                    (spots[j] as any).style.display = "none";
                }
            }
        }

        let hotspots = document.getElementsByClassName(visibleCategory);
        for (let i = 0; i < hotspots.length; i++) {
            //hotspots[i].style.visibility = "visible";
            (hotspots[i] as any).style.display = "block";
        }
    }

    panoramaLoadedListener() {
        const { selected } = this.state;
        this.onSelect(selected);
    }

    sceneChangeListener(sceneId) {
        this.currentScene = sceneId;
    }

    render() {
        const { selected } = this.state;

        return (
            <ScrollMenu
                ref={this.scrollMenu}
                data={this.menuItems}
                arrowLeft={ArrowLeft}
                arrowRight={ArrowRight}
                hideSingleArrow={true}
                hideArrows={true}
                selected={selected}
                onSelect={this.onSelect}
                translate={0}
                alignCenter={true}
                alignOnResize={true}
                dragging={true}
                scrollToSelected={true}/>
        );
    }
}

const init360CategoryMenu = (viewer, categories, scenes) => {
    const menuDiv = document.getElementById("sd360tour-category-menu");
    if (categories.length > 0) {
        if (menuDiv != null) {
            // Add default category
            let config = viewer.getConfig();
            let defaultCategoryName = config.tourOptions?.defaultCategoryName ?? "Default";
            let defaultCategory = { id: "", name: "Default", displayName: defaultCategoryName };
            categories.splice(0, 0, defaultCategory);

            ReactDOM.render(<Category360Menu viewer={viewer} categories={categories} scenes={scenes} />, menuDiv);
            //UiUtils.showUiElement("sd360tour-category-menu");
            $("#sd360tour-category-menu").removeClass("d-none");
        }
    }
}

export { init360CategoryMenu }